import { StatusModel } from "../../general";

export interface PeripheralTopicItemModel {
  id: string;
  title: string;
  status: StatusModel;
  icon: string;
  message: string;
  isActive?: boolean;
  isRecognized?: boolean;
  children?: PeripheralTopicItemModel[];
}